import React, { useEffect, useState } from 'react';
import { SwoopyWordmark } from './SwoopyLogo';

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);
  // 0=init, 1=fadeIn, 2=motion, 3=hold, 4=exit

  useEffect(() => {
    // Phase 1: Fade in (after small delay)
    const t1 = setTimeout(() => setPhase(1), 50);
    
    // Phase 2: Subtle motion
    const t2 = setTimeout(() => setPhase(2), 350);
    
    // Phase 3: Hold static
    const t3 = setTimeout(() => setPhase(3), 650);
    
    // Phase 4: Exit
    const t4 = setTimeout(() => setPhase(4), 1250);
    
    // Complete
    const t5 = setTimeout(() => onComplete(), 1600);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
    };
  }, [onComplete]);

  const styles = {
    0: { opacity: 0, transform: 'scale(0.94)' },
    1: { opacity: 1, transform: 'scale(1)' },
    2: { opacity: 1, transform: 'scale(1) rotate(1deg) translateY(-2px)' },
    3: { opacity: 1, transform: 'scale(1) rotate(0deg) translateY(0)' },
    4: { opacity: 0, transform: 'scale(1.02)' },
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center"
      style={{ backgroundColor: 'var(--clay-white)' }}
    >
      {/* Subtle background glow */}
      <div 
        style={{
          position: 'absolute',
          width: '200px',
          height: '100px',
          background: 'radial-gradient(ellipse, rgba(233, 116, 143, 0.2) 0%, transparent 70%)',
          filter: 'blur(40px)',
          pointerEvents: 'none'
        }}
      />
      
      <div
        style={{
          ...styles[phase],
          transition: phase === 1 
            ? 'opacity 300ms ease-out, transform 300ms ease-out'
            : phase === 4
            ? 'opacity 280ms ease-out, transform 280ms ease-out'
            : 'transform 300ms ease-out',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* Logo - Just the word "Swoopy" */}
        <SwoopyWordmark size="xl" />
        <p 
          style={{ 
            marginTop: '16px',
            fontSize: '13px',
            fontWeight: '400',
            letterSpacing: '0.12em',
            color: 'var(--text-muted)',
            fontFamily: "'Fredoka', system-ui, sans-serif"
          }}
        >
          Swoop. Sip. Go.
        </p>
      </div>
    </div>
  );
}
